module.exports = "/assets/bw-main.png?R0VpCw7";